import React,{useState} from 'react'
import { NavLink, useNavigate, useLocation } from 'react-router-dom'
import Loader from '../../utils/Loader'
import { toast } from 'react-toastify';
import {ResetPasswordRequest} from '../../redux/reducer/FetchDataReducer'
import { useSelector, useDispatch } from 'react-redux'

const ResetPassword = () => {
  const [password, setpassword] = useState('')
  const [confirmPassword, setconfirmPassword] = useState('')
  let navigate = useNavigate();
  const dispatch = useDispatch()
  const userName = useLocation();
  var User = userName.state && userName.state.user
  console.log(User)
  const fetchReducer = useSelector((state) => state.fetchDataReducer)


  const SubmitHandler = () => {
    if(password == ''){
      toast.error("Password is required");
    } else if(confirmPassword == ''){
      toast.error("Confirm Password is required");
    } else if(password !== confirmPassword){
      toast.error("Confirm Password does not match");
    } else {
      let obj ={
        "email": User?.user?.email,
        "otp": User?.otp?.otp,
        "password" : password,
        "password_confirmation":confirmPassword
      }

      dispatch(ResetPasswordRequest({obj:obj,navigate:navigate}))
    }
  }


  return (
    <>
    <div className='top-b-header'>
      
      <NavLink to="/forgot-password">
      <i className="fa-solid fa-arrow-left"></i>
      </NavLink>
    
      <h3>Verify OTP</h3>
      <div></div>
  </div>

    <div className='container'>
    <Loader visible={fetchReducer.isloading} />
    <div className='forgot-screen'>
        <img src='images/reset.png'/>
        <h3>Create New Password</h3>
        <p>Enter new password</p>
        <div className='form-group'>
            <label>New Password</label>
          <input type="password" className='form-control' placeholder='****' 
            value={password}
            onChange={(e) => setpassword(e.target.value)}
          />
        </div>
        <div className='form-group'>
        <label>Confirm New Password</label>
          <input type="password" className='form-control' placeholder='****' 
           value={confirmPassword}
           onChange={(e) => setconfirmPassword(e.target.value)}
          />
        </div>
        <div className='form-group'>
                <button type='button' className='login-btn' onClick={SubmitHandler}>Submit</button>
            </div>
    </div>
    </div>
   
    </>
  )
}

export default ResetPassword